import InsiderConfig from './insider/insider-config';
import SingularConfig from './singular/singular-config';
import RudderConfig from './rudder/rudder-config';

export default { InsiderConfig, SingularConfig, RudderConfig };
